module.exports = __webpack_public_path__ + "95ec25640c911126b02be4702192c98b.svg";